import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  makeStyles,
  Fab,
  Link
} from '@material-ui/core';
import { AlertCircle, CheckCircle, Mail } from 'react-feather';
import { green, red } from '@material-ui/core/colors';
import { AccountBalanceWallet } from '@material-ui/icons';
import moment from 'moment';
import CustomDialog from 'src/components/CustomDialog';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    height: 100,
    width: 100
  }
}));

const Profile = ({
  className,
  customer,
  summary,
  handleVerification,
  ...rest
}) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);

  const [dialogObj, setDialogObj] = useState({
    title: '',
    message: '',
    open: dialogOpen,
    action: () => console.log('No action specified')
  });

  const riderButton = customer.verifiedRider ? (
    <Button
      style={{ color: green[600] }}
      size="small"
      className={classes.button}
      startIcon={<CheckCircle />}
      onClick={() => {
        setDialogObj({
          title: `Unverify ${customer.firstName} ${customer.lastName}?`,
          message: 'Are you sure you want to unverify this user as rider',
          action: () => {
            handleVerification({ riderVerify: false });
            setDialogOpen(false);
          }
        });

        setDialogOpen(true);
      }}
    >
      Rider
    </Button>
  ) : (
    <Button
      style={{ color: red[600] }}
      size="small"
      className={classes.button}
      startIcon={<AlertCircle />}
      onClick={() => {
        setDialogObj({
          title: `Verify ${customer.firstName} ${customer.lastName}?`,
          message: 'Are you sure you want to verify this user as rider',
          action: () => {
            handleVerification({ riderVerify: true });
            setDialogOpen(false);
          }
        });
        setDialogOpen(true);
      }}
    >
      Rider
    </Button>
  );

  const driverButton = customer.verifiedDriver ? (
    <Button
      style={{ color: green[600] }}
      size="small"
      className={classes.button}
      startIcon={<CheckCircle />}
      onClick={() => {
        setDialogObj({
          title: `Unverify ${customer.firstName} ${customer.lastName}?`,
          message: 'Are you sure you want to unverify this user as driver',
          action: () => {
            handleVerification({ driverVerify: false });
            setDialogOpen(false);
          }
        });

        setDialogOpen(true);
      }}
    >
      Driver
    </Button>
  ) : (
    <Button
      style={{ color: red[600] }}
      size="small"
      className={classes.button}
      startIcon={<AlertCircle />}
      onClick={() => {
        setDialogObj({
          title: `Verify ${customer.firstName} ${customer.lastName}?`,
          message: 'Are you sure you want to verify this user as driver',
          action: () => {
            handleVerification({ driverVerify: true });
            setDialogOpen(false);
          }
        });
        setDialogOpen(true);
      }}
    >
      Driver
    </Button>
  );

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CustomDialog
        title={dialogObj.title}
        message={dialogObj.message}
        open={dialogOpen}
        handleDialogClose={() => setDialogOpen(false)}
        action={dialogObj.action}
      />
      <CardContent>
        <Box alignItems="center" display="flex" flexDirection="column">
          <Avatar
            className={classes.avatar}
            src={customer.photographUrl || '/broken-image.jpg'}
          />
          <Typography color="textPrimary" gutterBottom variant="h3">
            {`${customer.firstName || ''} ${customer.lastName || ''}`}
          </Typography>
          <Typography color="textSecondary" gutterBottom variant="body1">
            {customer.miniBio || ''}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Member since: {moment(customer.createdAt).format('DD MMM YYYY')}
          </Typography>
        </Box>
      </CardContent>
      <Divider />
      <CardContent
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center'
        }}
      >
        {riderButton}

        {driverButton}
        <Fab
          color="primary"
          size="small"
          aria-label="add"
          component={RouterLink}
          to={`/app/message/new?email=${customer.email}`}
        >
          <Mail />
        </Fab>
      </CardContent>
      <Divider />
      <CardContent
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          textAlign: 'center'
        }}
      >
        <Link
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          onClick={() => navigate(`/app/customers/trips/${customer.id}`)}
        >
          <Typography color="textPrimary" gutterBottom variant="h5">
            {summary.totalSuccessfulTripCount || 0}
          </Typography>
          <Typography variant="overline" display="block" gutterBottom>
            Trips
          </Typography>
        </Link>
        <Link
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          onClick={() => navigate(`/app/customers/bookings/${customer.id}`)}
        >
          <Typography color="textPrimary" gutterBottom variant="h5">
            {summary.totalBookingsCount || 0}
          </Typography>
          <Typography variant="overline" display="block" gutterBottom>
            Bookings
          </Typography>
        </Link>
        <Link
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          // onClick={() => navigate(`/app/customers/bookings/${customer.id}`)}
        >
          <Typography color="textPrimary" gutterBottom variant="h5">
            0
          </Typography>
          <Typography variant="overline" display="block" gutterBottom>
            Payouts
          </Typography>
        </Link>
      </CardContent>
      <Divider />
      <CardContent
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          textAlign: 'center'
        }}
      >
        <Link
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          onClick={() => navigate(`/app/customers/wallet/${customer.walletId}`)}
        >
          <AccountBalanceWallet fontSize="large" />
          <Typography color="textPrimary" gutterBottom variant="h5">
            Wallet
          </Typography>
        </Link>
      </CardContent>
    </Card>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.object,
  summary: PropTypes.object,
  handleVerification: PropTypes.func
};

export default Profile;
